'use client';

import type { ParentOrderInfo } from 'src/@types/historyTables';
import NumberDisplay from 'src/components/NumberDisplay/NumberDisplay';
import { isEntirePositionOrder } from '@drift/common';
import type { AmountDisplayType } from '../TradePageOrderHistoryTable';

interface OrderedSizeCellProps {
	order: ParentOrderInfo;
	amountDisplayType: AmountDisplayType;
}

export function OrderedSizeCell({
	order,
	amountDisplayType,
}: OrderedSizeCellProps) {
	const { baseAssetAmount, price } = order;

	if (isEntirePositionOrder(baseAssetAmount)) {
		return 'Entire Position';
	}

	if (amountDisplayType === 'base') {
		return (
			<NumberDisplay
				value={baseAssetAmount}
				type="number"
				precision="trade"
				isAccountValueToHide
				trimZeroes
			/>
		);
	}

	if (price.eqZero()) {
		return 'Market';
	}

	return (
		<NumberDisplay
			value={baseAssetAmount.mul(price).shiftTo(price.precision)}
			type="currency"
			isAccountValueToHide
		/>
	);
}
